import type { Entity } from '@backstage/catalog-model';

export const isAgentEntity = (entity: Entity) => {
  return (
    entity.kind.toLocaleLowerCase('en-US') === 'airesource' &&
    entity.spec?.type === 'agent'
  );
};

export const isAdditionalInfoEntity = (entity: Entity) => {
  const kind = entity.kind.toLocaleLowerCase('en-US');
  const isNotGroupOrUser = kind !== 'group' && kind !== 'user';

  return isNotGroupOrUser;
};
